export const homePageMenuType = {
  defaultMenu: 1,
  bottomPanel: 2,
  bottomList: 3
}



// WEBPACK FOOTER //
// ./scripts/src/shared/enums/menu.type.js